import postWithToken from './base/post-with-token'

const addSettingUrlFeedBack = (data) => postWithToken(`/provide-feedback/update`)({data})

export default addSettingUrlFeedBack